import { DataFetchingThunkAction } from '../types';
import {
    FETCH_DYNAMIC_SEARCH_SUGGESTIONS,
    CLEAR_DYNAMIC_SEARCH_SUGGESTIONS,
    FETCH_DYNAMIC_SEARCH_SUGGESTIONS_SUCCESS,
    FETCH_DYNAMIC_SEARCH_SUGGESTIONS_FAILED,
    FetchDynamicSearchSuggestionsAction,
    ClearDynamicSearchSuggestionsAction,
    FetchDynamicSearchSuggestionsSuccessAction,
    FetchDynamicSearchSuggestionsFailedAction,
    DynamicSearchSuggestionsResponse,
    SetDynamicSearchQueryAction,
    SET_DYNAMIC_SEARCH_QUERY,
    ENTER_KEY_DYNAMIC_SEARCH_ACTION,
    EnterKeyDynamicSearchAction,
    REAL_DYNAMIC_SEARCH_ACTION,
    RealDynamicSearchAction,
    FETCH_DYNAMIC_SEARCH_REDIRECT,
    FetchDynamicSearchRedirectsAction,
    FetchDynamicSearchRedirectSuccessAction,
    FETCH_DYNAMIC_SEARCH_REDIRECT_SUCCESS,
    FetchDynamicSearchRedirectFailedAction,
    FETCH_DYNAMIC_SEARCH_REDIRECT_FAIL,
    DynamicSearchRedirectsResponse,
    CLICKED_DYNAMIC_SEARCH_SUGGESTION_ACTION,
    ClickedDynamicSearchSuggestionAction,
    CLEAR_DYNAMIC_SEARCH_METRICS,
} from './types';
import { getErrorCustomData } from 'Common/errors/CustomFetchApiError';

export const isFetchingDynamicSearchSuggestionAction = (): FetchDynamicSearchSuggestionsAction => ({
    type: FETCH_DYNAMIC_SEARCH_SUGGESTIONS,
});

export const handleEnterKeyDynamicSearchAction = (isEnterKeySearch: boolean): EnterKeyDynamicSearchAction => ({
    type: ENTER_KEY_DYNAMIC_SEARCH_ACTION,
    payload: { isEnterKeySearch },
});

export const isRealDynamicSearchAction = (isRealSearch: boolean): RealDynamicSearchAction => ({
    type: REAL_DYNAMIC_SEARCH_ACTION,
    payload: { isRealSearch },
});

export const clickedDynamicSearchSuggestion = (clickedSuggestion: string): ClickedDynamicSearchSuggestionAction => ({
    type: CLICKED_DYNAMIC_SEARCH_SUGGESTION_ACTION,
    payload: { clickedSuggestion },
});

export const clearDynamicSearchMetrics = () => ({
    type: CLEAR_DYNAMIC_SEARCH_METRICS,
});

export const fetchDynamicSearchSuggestionsSuccessAction = (
    response: DynamicSearchSuggestionsResponse
): FetchDynamicSearchSuggestionsSuccessAction => ({
    type: FETCH_DYNAMIC_SEARCH_SUGGESTIONS_SUCCESS,
    payload: response,
});

export const fetchDynamicSearchSuggestionsFailedAction = (error: Error): FetchDynamicSearchSuggestionsFailedAction => ({
    type: FETCH_DYNAMIC_SEARCH_SUGGESTIONS_FAILED,
    payload: error,
});

export const clearDynamicSearchSuggestionsAction = (exemptQuery?: boolean): ClearDynamicSearchSuggestionsAction => ({
    type: CLEAR_DYNAMIC_SEARCH_SUGGESTIONS,
    payload: { exemptQuery },
});

export const fetchDynamicSearchSuggestionsAction = (): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    const { query } = getState().dynamicSearchSuggestions;
    if (!query) {
        return;
    }
    dispatch(isFetchingDynamicSearchSuggestionAction());
    try {
        const response = await apiService.shopApi.getDynamicSearchSuggestions(query);
        if (query !== getState().dynamicSearchSuggestions.query) {
            return;
        }
        dispatch(fetchDynamicSearchSuggestionsSuccessAction(response));
    } catch (err) {
        logger.error(err, { action: 'fetchDynamicSearchSuggestionsFailedAction', ...getErrorCustomData(err) });
        dispatch(fetchDynamicSearchSuggestionsFailedAction(err));
    }
};

export const setDynamicSearchQueryAction = (query: string): SetDynamicSearchQueryAction => ({
    type: SET_DYNAMIC_SEARCH_QUERY,
    payload: { query },
});

export const isFetchingDynamicSearchRedirectAction = (): FetchDynamicSearchRedirectsAction => ({
    type: FETCH_DYNAMIC_SEARCH_REDIRECT,
});

export const fetchDynamicSearchRedirectSuccessAction = (
    response: DynamicSearchRedirectsResponse
): FetchDynamicSearchRedirectSuccessAction => ({
    type: FETCH_DYNAMIC_SEARCH_REDIRECT_SUCCESS,
    payload: response,
});

export const fetchDynamicSearchRedirectFailedAction = (error: Error): FetchDynamicSearchRedirectFailedAction => ({
    type: FETCH_DYNAMIC_SEARCH_REDIRECT_FAIL,
    payload: error,
});

export const fetchDynamicSearchRedirectsIfNeeded = (search?: string): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    const { query } = getState().dynamicSearchSuggestions;
    const searchParam = query || search;
    if (!searchParam) {
        return;
    }
    dispatch(isFetchingDynamicSearchRedirectAction());
    try {
        const searchRedirectResponse = await apiService.shopApi.getSearchRedirects(searchParam);
        if (query !== getState().dynamicSearchSuggestions.query) {
            return;
        }
        dispatch(fetchDynamicSearchRedirectSuccessAction(searchRedirectResponse));
    } catch (err) {
        logger.error(err, { action: 'fetchDynamicSearchRedirectFailedAction', ...getErrorCustomData(err) });
        dispatch(fetchDynamicSearchRedirectFailedAction(err));
    }
};
